const styles = () => ({
  container: {
    width: 'calc(100% - 33px)',
    padding: '0px 10px',
    position: 'relative',

    '&.mobile': {
      width: '100%',
      paddingTop: '30px',
      paddingBottom: '150px',
    },
  },
  videoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  videoPlayer: {
    maxHeight: '80vh',
    maxWidth: '100%',
  },
  previewZoomButtons: {
    position: 'fixed',
    right: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',

    '&.mobile': {
      top: '-1px',
      right: '5px',
      marginTop: '38px',
    },

    '& button': {
      background: '#8d8d8d',
      border: 'unset',
      outline: 'unset',
      margin: '10px 0 0 0',
      padding: '10px',
      borderRadius: '100%',
      cursor: 'pointer',
    },

    '& svg': {
      display: 'block',
      width: '19px',
      height: '19px',
      color: '#FC6865',
    },
  },
  pdfViewer: {
    display: 'block',
    '& canvas': {
      margin: '0 auto',
    },
  },
  wrapperClass: {
    position: 'fixed',
    width: '100%',
    height: '100vh',
    left: '0',
    top: '0',
    overflow: 'auto',
    background: '#717171',
  },
});

export default styles;
